import { render, staticRenderFns } from "./FacturationDetail.vue?vue&type=template&id=44965ce7&"
import script from "./FacturationDetail.vue?vue&type=script&lang=js&"
export * from "./FacturationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports